import axios from "axios";
import { useSnackbar } from "notistack";
import { useEffect } from "react";

const apiHost = process.env.REACT_APP_API_HOST;
const postHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const instance = axios.create({
  baseURL: apiHost,
  headers: { ...postHeaders },
  timeout: 10 * 60 * 1000,
});

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;

const AxiosInterceptor = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    const interceptor = instance.interceptors.response.use(
      null,
      async (err) => {
        if (err?.response?.status === 403) {
          enqueueSnackbar("Please check with the admin", {
            variant: "error",
            preventDuplicate: true,
            autoHideDuration: 1500,
          });
        }
        return Promise.reject(err);
      }
    );
    return () => instance.interceptors.response.eject(interceptor);
  }, []);

  return children;
};

export default instance;

export { AxiosInterceptor };
